(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fos-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fmt(t) {
    if (!isFinite(t)) return '–:––';
    var m = Math.floor(t / 60), s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function init(root) {
    if (!root || root.dataset.fosReady) return;
    root.dataset.fosReady = '1';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    root.querySelectorAll('.fos-reveal').forEach(function (el) { io.observe(el); });

    var bar = root.querySelector('[data-fos-countdown]');
    var deadline = Date.parse(root.dataset.deadline || '');
    if (bar && deadline && deadline > Date.now()) {
      bar.hidden = false;
      var units = {};
      bar.querySelectorAll('[data-u]').forEach(function (b) { units[b.dataset.u] = b; });
      var tick = function () {
        var left = Math.max(0, deadline - Date.now());
        if (!left) { bar.hidden = true; clearInterval(timer); return; }
        var vals = { d: Math.floor(left / 864e5), h: Math.floor(left / 36e5) % 24, m: Math.floor(left / 6e4) % 60, s: Math.floor(left / 1e3) % 60 };
        Object.keys(vals).forEach(function (k) {
          var v = (vals[k] < 10 ? '0' : '') + vals[k];
          if (units[k] && units[k].textContent !== v) {
            units[k].textContent = v;
            if (!reduce) { units[k].classList.remove('fos-tick'); void units[k].offsetWidth; units[k].classList.add('fos-tick'); }
          }
        });
      };
      var timer = setInterval(tick, 1000);
      tick();
    }

    var variant = root.dataset.variant;
    root.querySelectorAll('[data-fos-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!variant) return;
        btn.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          window.location.href = '/checkout';
        }).catch(function () {
          window.location.href = '/cart/' + variant + ':1';
        });
      });
    });

    var rotation = root.querySelector('[data-fos-rotation]');
    var demo = root.querySelector('[data-fos-demo]');
    if (rotation && demo) {
      try {
        var list = JSON.parse(rotation.textContent).filter(Boolean);
        if (list.length) {
          var hours = Number(demo.dataset.rotateHours) || 12;
          var pick = list[Math.floor(Date.now() / (hours * 36e5)) % list.length];
          demo.dataset.src = pick.src;
          var nameEl = demo.querySelector('[data-fos-demo-name]');
          if (nameEl) nameEl.textContent = '\u25B8 ' + pick.name;
          var demoBtn = demo.querySelector('[data-fos-toggle]');
          if (demoBtn) demoBtn.setAttribute('aria-label', 'Play ' + pick.name);
        }
      } catch (e) {}
    }

    var audio = new Audio();
    audio.preload = 'none';
    var current = null;

    function paint(track) {
      var p = audio.duration ? audio.currentTime / audio.duration : 0;
      var time = track.querySelector('[data-fos-time]');
      if (time) time.textContent = fmt(audio.currentTime) + (audio.duration ? ' / ' + fmt(audio.duration) : '');
      var fill = track.querySelector('.fos-track__bar');
      if (fill) fill.style.setProperty('--p', (p * 100).toFixed(2) + '%');
      var bars = track.querySelectorAll('.fos-wave i');
      if (bars.length) {
        var cut = Math.round(p * bars.length);
        bars.forEach(function (b, i) { b.classList.toggle('is-past', i < cut); });
      }
    }

    function stop() {
      if (!current) return;
      current.classList.remove('is-playing');
      var btn = current.querySelector('[data-fos-toggle]');
      if (btn) btn.setAttribute('aria-pressed', 'false');
    }

    function play(track) {
      if (current === track) {
        if (audio.paused) { audio.play(); track.classList.add('is-playing'); }
        else { audio.pause(); track.classList.remove('is-playing'); }
        return;
      }
      stop();
      current = track;
      audio.src = track.dataset.src;
      audio.play().catch(function () {});
      track.classList.add('is-playing');
      var btn = track.querySelector('[data-fos-toggle]');
      if (btn) btn.setAttribute('aria-pressed', 'true');
    }

    audio.addEventListener('timeupdate', function () { if (current) paint(current); });
    audio.addEventListener('loadedmetadata', function () { if (current) paint(current); });
    audio.addEventListener('ended', function () { stop(); });

    root.querySelectorAll('[data-fos-track]').forEach(function (track) {
      var btn = track.querySelector('[data-fos-toggle]');
      if (btn) btn.addEventListener('click', function () { play(track); });
      var seek = track.querySelector('[data-fos-seek]');
      if (seek) seek.addEventListener('click', function (e) {
        var r = seek.getBoundingClientRect();
        var ratio = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
        if (current !== track) play(track);
        var go = function () { if (audio.duration) { audio.currentTime = ratio * audio.duration; paint(track); } };
        if (audio.readyState >= 1) go(); else audio.addEventListener('loadedmetadata', go, { once: true });
      });
    });

    var tabs = root.querySelector('[data-fos-tabs]');
    if (tabs) {
      var list = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      var select = function (tab, focus) {
        list.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      };
      list.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (n === null) return;
          e.preventDefault();
          select(list[(n + list.length) % list.length], true);
        });
      });
    }

    var count = root.querySelector('[data-fos-count]');
    if (count && !reduce) {
      var target = Number(count.dataset.fosCount) / 100;
      var finalText = count.textContent;
      var symbol = finalText.replace(/[\d.,\s]/g, '') || '$';
      var cio = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        cio.disconnect();
        var t0 = performance.now();
        var step = function (now) {
          var k = Math.min(1, (now - t0) / 1200);
          var e = 1 - Math.pow(1 - k, 3);
          count.textContent = k < 1 ? symbol + (target * e).toFixed(2) : finalText;
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }, { threshold: 0.6 });
      cio.observe(count);
    }

    var moreBtn = root.querySelector('[data-fos-more]');
    if (moreBtn) moreBtn.addEventListener('click', function () {
      root.querySelectorAll('.fos-more-item[hidden]').forEach(function (el) { el.hidden = false; });
      moreBtn.remove();
    });

    var sticky = root.querySelector('[data-fos-sticky]');
    var heroCta = root.querySelector('[data-fos-hero-cta]');
    var finalSec = root.querySelector('[data-fos-final]');
    if (sticky && heroCta) {
      var state = { hero: true, final: false };
      var update = function () {
        var show = !state.hero && !state.final;
        sticky.classList.toggle('is-shown', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = sticky.querySelector('button');
        if (b) b.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (es) { state.hero = es[0].isIntersecting || es[0].boundingClientRect.top > 0; update(); }).observe(heroCta);
      if (finalSec) new IntersectionObserver(function (es) { state.final = es[0].isIntersecting; update(); }, { threshold: 0.25 }).observe(finalSec);
    }
  }

  function boot() { document.querySelectorAll('[data-fos]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-fos]')); });
})();

  } catch(e) { console.error(e); }
})();
})();
